import { inject } from "@angular/core";
import { catchError, finalize, map, of } from "rxjs";
import { AuthService } from "../../domain/auth/application/auth.service";
import { UserStore } from "../store/user.store";
import { LoaderStore } from "../store/loader.store";

/**
 * canMatch guard for routes that render with the full authenticated app shell when a
 * session exists, but should fall through to a sibling public route — rather than
 * redirecting away — when the visitor is signed out (e.g. browsing /events as a guest).
 * Unlike authGuard, returning `false` here lets the router try the next route config
 * for the same path instead of ending navigation.
 */
export function authenticatedMatchGuard() {
  const userStore = inject(UserStore);
  const authService = inject(AuthService);
  const loaderStore = inject(LoaderStore);

  if (userStore.user()) return true;

  loaderStore.show();

  return authService.getSession().pipe(
    map((session) => {
      if (!session) return false;
      userStore.setUser(session.user);
      return true;
    }),
    catchError(() => of(false)),
    finalize(() => loaderStore.hide())
  );
}
